/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusSystemNumberDto
 */
export interface NovitusSystemNumberDto {
    /**
     * Drukuj jako
     * @type {string}
     * @memberof NovitusSystemNumberDto
     */
    print_as: NovitusSystemNumberDtoPrintAsEnum;
    /**
     * Wartość do wydrukowania
     * @type {string}
     * @memberof NovitusSystemNumberDto
     */
    value: string;
}


/**
 * @export
 */
export const NovitusSystemNumberDtoPrintAsEnum = {
    text: 'text',
    barcode: 'barcode',
    qrcode: 'qrcode'
} as const;
export type NovitusSystemNumberDtoPrintAsEnum = typeof NovitusSystemNumberDtoPrintAsEnum[keyof typeof NovitusSystemNumberDtoPrintAsEnum];


/**
 * Check if a given object implements the NovitusSystemNumberDto interface.
 */
export function instanceOfNovitusSystemNumberDto(value: object): value is NovitusSystemNumberDto {
    if (!('print_as' in value) || value['print_as'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusSystemNumberDtoFromJSON(json: any): NovitusSystemNumberDto {
    return NovitusSystemNumberDtoFromJSONTyped(json, false);
}

export function NovitusSystemNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusSystemNumberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'print_as': json['print_as'],
        'value': json['value'],
    };
}

export function NovitusSystemNumberDtoToJSON(value?: NovitusSystemNumberDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'print_as': value['print_as'],
        'value': value['value'],
    };
}

